export interface ClickEmailVerifyArgs {
    verifyEmailHttpPath: string
    auth0Id: string

    onVerifySendError: () => void
    onVerifySendSuccessful: () => void
}

export const onClickEmailVerify = async ({
    verifyEmailHttpPath,
    auth0Id,
    onVerifySendError,
    onVerifySendSuccessful,
}: ClickEmailVerifyArgs) => {
    const request = 'send-verification-email'

    const response = await fetch(verifyEmailHttpPath, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId: auth0Id }),
    })

    // Send return type and handle functions based on the response
    if (!response.ok || response.status !== 201) {
        onVerifySendError()
        throw new Error(`Network error in ${request}`)
    }

    onVerifySendSuccessful()
}
